<template>
  <div>
    <div class="app-date-time">
      <i class="far fa-calendar-alt" />
      {{ formattedDateTime }} Hrs
    </div>
    <div>
      Dispensación: {{location}}
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  name: 'AppDateTime',
  props: {
    updateDelay: {
      type: Number,
      default: 1000
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY HH:mm'
    },
    icon: {
      type: String,
      default: ''
    },
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      formattedDateTime: dayjs().format(this.format),
      timeout: null
    };
  },
  created() {
    this.setTimer();
  },
  computed : {
    location(){
      let orgs = this.user.organizations;

      for (let key in orgs){
        if (orgs[key].uuid == this.$store.getters.activeOrganizationUuid){
          return orgs[key].name + ' - ' + orgs[key].address;
        }
      }

      return '';
    }
  },
  methods: {
    setTimer() {
      clearTimeout(this.timeout);
      if (this.updateDelay !== Infinity && this.updateDelay >= 0) {
        this.timeout = setTimeout(() => {
          this.updateDateTime();
          this.setTimer();
        }, this.updateDelay);
      }
    },
    updateDateTime() {
      this.formattedDateTime = dayjs().format(this.format);
    }
  }
};
</script>

<style lang="scss">
  .app-date-time {
    font-size: 14px;
    opacity: .6;
  }
</style>
